export interface AnimoLabel {
    labelType: number;
    startTime: number;
    endTime: number;
    temperature: number;
    heartRate: number;
    heartRateConfidence: number;
    respRate: number;
    respRateConfidence: number;
    labelId?: string;
}

export class LabelDataUtil {
    static validateAnimoLabel(label: AnimoLabel): boolean {
        const maxTimeDifference = 48 * 60 * 60 * 1000; // 48 hours in milliseconds
        
        // Check if end time is after start time
        if (label.startTime >= label.endTime) {
            return false;
        }

        // Check if the duration is within the maximum allowed time
        return (label.endTime - label.startTime) <= maxTimeDifference;
    }

    static handleLabelData(buffer: ArrayBuffer): AnimoLabel {
        const view = new DataView(buffer);
        return {
            labelType: view.getInt16(0, true), // true for little-endian
            startTime: Number(view.getBigInt64(2, true)),
            endTime: Number(view.getBigInt64(10, true)),
            temperature: view.getFloat32(18, true),
            heartRate: view.getFloat32(22, true),
            heartRateConfidence: view.getFloat32(26, true),
            respRate: view.getFloat32(30, true),
            respRateConfidence: view.getFloat32(34, true)
        };
    }
}
